// extracted by mini-css-extract-plugin
module.exports = {"colorInput":"input-color_colorInput__2wziT"};